import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, ListItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import { getFileNameWithoutExtension } from '../../utils';

const useStyles = makeStyles(theme => ({
  textSelectBox: {
    height: '24px',
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: ' 0.13px',
    color: '#88898c',
  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  listItem: {
    padding: 8
  }
}));

function SelectBoxTemplateList({ list, onChangeTemplate }) {
  const translate = useTranslate();
  const classes = useStyles();

  if (list.length === 0) {
    return (
      <ListItem className={classes.listItem} button onClick={() => onChangeTemplate()}>
        <Typography className={classes.textSelectBox}>{translate(`resources.messages.empty`)}</Typography>
      </ListItem>
    );
  }
  return (
    list.map(item => (
      <Box key={'select-box-template-' + item.id} className={classes.boxBoder}>
        <ListItem className={classes.listItem} button onClick={() => onChangeTemplate(item)}>
          <Typography className={classes.textSelectBox}>{getFileNameWithoutExtension(item.name)}</Typography>
        </ListItem>
      </Box>
    ))
  );
}

SelectBoxTemplateList.propTypes = {
  list: PropTypes.array.isRequired,
  onChangeTemplate: PropTypes.func.isRequired,
};

export default SelectBoxTemplateList;
